var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup221(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 103,
    viewBox: "0 0 101 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#DEF6FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1213_834)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5344 60.6471V44.1764C44.5344 35.0941 51.9226 27.7058 61.005 27.7058C70.0873 27.7058 77.4756 35.0941 77.4756 44.1764H82.1814C82.1815 32.5012 72.6803 23 61.005 23C49.3298 23 39.8285 32.5012 39.8285 44.1765V60.6471H30.4167V93.5883C30.4167 98.7788 34.6379 103 39.8285 103H82.1814C87.372 103 91.5932 98.7788 91.5932 93.5883V60.647H44.5344V60.6471ZM58.652 88.8823H63.3579V74.7647H58.6521V88.8823H58.652Z",
    fill: "#322FB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1213_834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(21 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup221);
export default __webpack_public_path__ + "static/media/Group 221.c7cb9ffd3592f4cdd836b448b53bf5d0.svg";
export { ForwardRef as ReactComponent };